import React from "react";
import { SvgIcon } from "@material-ui/core";

const CheckSuccess = props => (
  <SvgIcon width="117" height="117" viewBox="0 0 117 117" {...props}>
    <g id="Grupo_1612" data-name="Grupo 1612" transform="translate(-629 -269)">
    <circle id="Elipse_22" data-name="Elipse 22" cx="49.5" cy="49.5" r="49.5" transform="translate(639 278)" fill="#f8f8f8"/>
    <g id="Elipse_21" data-name="Elipse 21" transform="translate(629 269)" fill="none" stroke="#ff8200" strokeWidth="1" opacity="0.24">
      <circle cx="58.5" cy="58.5" r="58.5" stroke="none"/>
      <circle cx="58.5" cy="58.5" r="58" fill="none"/>
    </g>
    <path id="check-light" d="M59.075,88.919,20.646,127.348,7.06,113.762a1.647,1.647,0,0,0-2.329,0l-1.553,1.553a1.647,1.647,0,0,0,0,2.329l16.3,16.3a1.647,1.647,0,0,0,2.329,0L62.957,92.8a1.647,1.647,0,0,0,0-2.329L61.4,88.919a1.647,1.647,0,0,0-2.329,0Z" transform="translate(654.231 215.673)" fill="#ff8200"/>
  </g>
  </SvgIcon>
);

export default CheckSuccess;
